import { useCallback, useEffect, useLayoutEffect, useState } from 'react'

import { confirmAlert } from 'react-confirm-alert'

import { MdEdit, MdClose } from 'react-icons/md'

import { useSelector } from 'react-redux'

import Button from '../../../components/Buttons/Button'

import Loading from '../../../components/Loading'

import { Header } from '../../../components/Main'

import List from '../../../components/Main/List'

import { Confirm } from '../../../components/Modal'

import history from '../../../routes/history'

import api from '../../../services/api'

import removerAcentos from '../../../utils/removerAcentos'

import { ContainerFilters } from './styles'

function Cursos(props) {
  const [loading, setLoading] = useState(true)
  const [packs, setPacks] = useState([])
  const [data, setData] = useState([])
  const { path } = props.match

  const { searchTermValue } = useSelector(state => state.search)

  const getPacks = useCallback(async () => {
    const response = await api.get('/packs')

    setPacks(response.data)
    setData([])
  }, [])

  const getProducts = useCallback(async slug => {
    if (!slug) return

    const response = await api.get('/produtos-list', {
      params: {
        pack: slug
      }
    })

    setData(response.data)
  }, [])

  const productsListSearch = useCallback(async () => {
    if (searchTermValue) {
      const response = await api.get('/produtos-list')

      setData(() => {
        return response.data.filter(element => {
          return removerAcentos(element.titulo.toLowerCase()).includes(
            searchTermValue.toLowerCase()
          )
        })
      })
    }
  }, [searchTermValue])

  const handleClickDelete = useCallback(
    async item => {
      const { id } = item

      await api.delete(`/produtos/${id}`)

      const newData = data.filter(data => data.id !== id)

      setData(newData)
    },
    [data]
  )

  const handleDelete = useCallback(
    data => {
      confirmAlert({
        overlayClassName: 'overlay-custom-class-name',
        customUI: function confirmDelete({ onClose }) {
          return (
            <Confirm
              onClose={onClose}
              handleClickDelete={() => handleClickDelete(data)}
            />
          )
        }
      })
    },
    [handleClickDelete]
  )

  useEffect(() => {
    productsListSearch()
  }, [productsListSearch])

  useEffect(() => {
    getPacks()
  }, [getPacks])

  useEffect(() => {
    getProducts()
  }, [getProducts])

  useLayoutEffect(() => {
    setTimeout(() => {
      setLoading(false)
    }, 1000)
  }, [])

  if (loading) {
    return <Loading />
  }

  return (
    <>
      <Header title="Cursos" path={`${path}/new`} />

      <ContainerFilters>
        {packs.map(pack => (
          <Button
            key={pack.id}
            onClick={() => getProducts(pack.slug)}
            type="button"
            transform="true"
            title={pack.nome}
            size="14"
          />
        ))}
      </ContainerFilters>

      <List>
        <thead>
          <tr>
            <th>ID</th>
            <th>Modo</th>
            <th>Nome</th>
            <th>Preço</th>
            <th>Data de Criação</th>
            <th>Opções</th>
          </tr>
        </thead>
        <tbody>
          {data.map(data => (
            <tr key={data.id}>
              <td data-label="ID">
                <div>{data.id}</div>
              </td>
              <td data-label="Modo">
                <div>{data.pack.nome}</div>
              </td>
              <td data-label="Nome">
                <div className="produto_link">{data.titulo}</div>
              </td>
              <td data-label="Preço">
                {Intl.NumberFormat('pt-PT', {
                  style: 'currency',
                  currency: 'EUR'
                }).format(data.preco)}
              </td>
              <td data-label="Data de Criação">
                <div>{data.created_at}</div>
              </td>
              <td data-label="Opções">
                <div className="container_opcoes">
                  <div
                    onClick={() => history.push(`/cursos/edit/${data.slug}`)}
                    className="opcoes"
                  >
                    <MdEdit size={21} color="var(--orange)" />
                  </div>
                  <div onClick={() => handleDelete(data)} className="opcoes">
                    <MdClose size={21} color="var(--orange)" />
                  </div>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </List>
    </>
  )
}

export default Cursos
